import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=a78d1c90&scoped=true"
import script from "./sButton.ts?vue&type=script&lang=ts&external"
export * from "./sButton.ts?vue&type=script&lang=ts&external"
import style0 from "./SButton.vue?vue&type=style&index=0&id=a78d1c90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78d1c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a78d1c90')) {
      api.createRecord('a78d1c90', component.options)
    } else {
      api.reload('a78d1c90', component.options)
    }
    module.hot.accept("./SButton.vue?vue&type=template&id=a78d1c90&scoped=true", function () {
      api.rerender('a78d1c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-button/SButton.vue"
export default component.exports